import { MappedClass, MappedProperty, MappedPropertyArray } from '@h5s/util-object';
import { AstatDailyMovement } from './astat-daily-movement';

@MappedClass()
export class CheckAstatDailyGuestsInClosurePeriodResponse {
  @MappedPropertyArray(() => AstatDailyMovement)
  movements: AstatDailyMovement[];

  @MappedProperty()
  zeroArrivesAndPresences: boolean;
}
